import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/muuri_styles.css';
import '../styles/add_pane.css';
import '../styles/modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import mixpanel from 'mixpanel-browser';
import Cookie from 'universal-cookie';
import swal from 'sweetalert'; // Added import for swal

function AddDashboardModal(props) {
    const cookies = new Cookie();
    const [dashboardName, setDashboardName] = useState(""); // State to hold input value

    const handleSubmit = (event) => {
        event.preventDefault();
        //console.log("Submitting dashboard name from modal:", dashboardName); // Debug log
        mixpanel.track("Add Dashboard Submit Button Clicked", { userID: cookies.get('userID') });
        if (dashboardName.trim() === "") {
            //console.log("Modal validation failed: Name is empty");
            swal("Dashboard name cannot be empty!", "", "error");
            return;
        }
        props.addDashboardHandler(dashboardName); // Pass the entered name
        props.setToggleAddDashboard(false);
    };

    return (
        <div className="modalOverlay">
            <div className="overlay"></div>
            <div className="modal-content">
                <div className="close-form">
                    <button
                        className="close-modal btn btn-danger"
                        onClick={() => props.setToggleAddDashboard(false)}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="form-settings">
                    <form onSubmit={handleSubmit}>
                        <div>
                            {/* Conditionally render the active dashboard name */}
                            {props.newDashboard && (
                                <div className="dashboard-name">
                                    <span>{props.newDashboard}</span>
                                </div>
                            )}
                            <div className="form-row">
                                <div className="form-label">
                                    <label>Dashboard Name</label>
                                </div>
                                <input
                                    className="dashboard-name-input"
                                    name="dashboard_name"
                                    placeholder="Enter dashboard name"
                                    value={dashboardName} // Tie input to state
                                    onChange={(e) => setDashboardName(e.target.value)} // Update state on change
                                    required // HTML5 validation for completeness
                                />
                            </div>
                            <button
                                type="submit" // Changed to type="submit" for form submission
                                className="btn btn-primary btn-sm btn-submit"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddDashboardModal;